import keyMirror from 'keymirror';
import { nameInUrlFormat, withLanguageLocale } from '../../services/Helper';
import { IS_MOBILE_APP } from '../../services/capacitor/Constants';

export const quizDetailsActionTypes = keyMirror({
	GET_QUIZ_DETAILS_REQUEST: null,
	GET_QUIZ_DETAILS_SUCCESS: null,
	GET_QUIZ_DETAILS_ERROR: null,
	DUPLICATE_USER_QUIZ_REQUEST: null,
	DUPLICATE_USER_QUIZ_SUCCESS: null,
	DUPLICATE_USER_QUIZ_ERROR: null,
	DELETE_USER_QUIZ_REQUEST: null,
	DELETE_USER_QUIZ_SUCCESS: null,
	DELETE_USER_QUIZ_ERROR: null,
});

export const getQuizDetailsEmptyStateInfo = (
	isNoQuestions,
	isLockedQuiz,
	progress,
	creatorName,
	isOwnQuiz,
	subjectName,
	canCreateLiveBattle,
	t,
) => {
	if (isNoQuestions) {
		return {
			title: t('quiz_details.empty_state.no_questions.title'),
			description: t('quiz_details.empty_state.no_questions.description'),
			btnTitle: '',
			showProgress: false,
			onClick: null,
			btnIcon: '',
			hideIcon: true,
			extraBtnIcon: '',
			extraBtnTitle: '',
			extraBtnOnClick: null,
		};
	}
	if (isLockedQuiz) {
		return {
			title: t('quiz_details.empty_state.quiz_is_locked.title'),
			description: t('quiz_details.empty_state.quiz_is_locked.description'),
			btnTitle: t('quiz_details.empty_state.quiz_is_locked.primary_btn_title'),
			showProgress: false,
			onClick: 'navigateToHome',
			btnIcon: '',
			hideIcon: true,
			extraBtnIcon: '',
			extraBtnTitle: '',
			extraBtnOnClick: null,
		};
	}
	if (canCreateLiveBattle && !IS_MOBILE_APP) {
		return {
			title:
				progress > 0 && progress < 100
					? t('quiz_details.empty_state.quiz_progress.title')
					: t('quiz_details.empty_state.no_quiz_progress.title', { subjectName }),
			description:
				progress > 0 && progress < 100
					? t('quiz_details.empty_state.no_quiz_progress.description', {
							firstName: creatorName,
					  })
					: t('quiz_details.empty_state.own_quiz.description'),
			btnTitle:
				progress > 0 && progress < 100
					? t('quiz_details.empty_state.quiz_progress.primary_btn_title')
					: t('quiz_details.empty_state.own_quiz.primary_btn_title'),
			showProgress: progress > 0 && progress < 100,
			onClick: progress > 0 && progress < 100 ? 'resumeQuiz' : 'createLiveBattle',
			btnIcon: 'play-circle-filled',
			hideIcon: false,
			extraBtnIcon: 'play-circle-filled',
			extraBtnTitle:
				progress > 0 && progress < 100
					? t('quiz_details.empty_state.own_quiz.primary_btn_title')
					: t('quiz_details.empty_state.own_quiz.secondary_btn_title'),
			extraBtnOnClick:
				progress > 0 && progress < 100 && !IS_MOBILE_APP ? 'createLiveBattle' : 'startQuiz',
		};
	}
	if (progress === 100) {
		return {
			title: t('quiz_details.empty_state.quiz_is_finished.title'),
			description: t('quiz_details.empty_state.quiz_is_finished.description'),
			btnTitle: t('quiz_details.empty_state.quiz_is_finished.extra_btn_title'),
			showProgress: false,
			onClick: 'restartQuiz',
			btnIcon: '',
			hideIcon: true,
			extraBtnIcon: 'play-circle-filled',
			extraBtnTitle: t('quiz_details.empty_state.own_quiz.create_friends_live_battle_btn'),
			extraBtnOnClick: IS_MOBILE_APP ? undefined : 'createLiveBattle',
		};
	}
	if (progress > 0 && progress < 100) {
		return {
			title: t('quiz_details.empty_state.quiz_progress.title'),
			description: isOwnQuiz
				? t('quiz_details.empty_state.no_quiz_progress.description_is_owner')
				: t('quiz_details.empty_state.no_quiz_progress.description', {
						firstName: creatorName,
				  }),
			btnTitle: t('quiz_details.empty_state.quiz_progress.primary_btn_title'),
			showProgress: true,
			onClick: 'resumeQuiz',
			btnIcon: 'play-circle-filled',
			hideIcon: false,
			extraBtnIcon: 'play-circle-filled',
			extraBtnTitle: t('quiz_details.empty_state.own_quiz.create_friends_live_battle_btn'),
			extraBtnOnClick: IS_MOBILE_APP ? undefined : 'createLiveBattle',
		};
	}

	return {
		title: t('quiz_details.empty_state.no_quiz_progress.title', { subjectName }),
		description: isOwnQuiz
			? t('quiz_details.empty_state.no_quiz_progress.description_is_owner')
			: t('quiz_details.empty_state.no_quiz_progress.description', {
					firstName: creatorName,
			  }),
		btnTitle: t('quiz_details.empty_state.no_quiz_progress.primary_btn_title'),
		showProgress: false,
		onClick: 'startQuiz',
		btnIcon: 'play-circle-filled',
		hideIcon: false,
		extraBtnIcon: 'play-circle-filled',
		extraBtnTitle: t('quiz_details.empty_state.own_quiz.create_friends_live_battle_btn'),
		extraBtnOnClick: IS_MOBILE_APP ? undefined : 'createLiveBattle',
	};
};

export const getQuizDetailsTabs = (quizId, title, t) => [
	{
		title: t('quiz_details.tabs.quiz'),
		value: '',
		link: withLanguageLocale(`/quizzes/${quizId}/${nameInUrlFormat(title)}`),
		index: 0,
	},
	{
		title: t('quiz_details.tabs.results'),
		value: 'results',
		link: withLanguageLocale(`/quizzes/${quizId}/${nameInUrlFormat(title)}/results`),
		index: 1,
	},
];
